import React, {
  FunctionComponent,
  useEffect,
  useState,
} from "react";

import { Tooltip } from "antd";
import ctx from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { getCognitoUserData } from "../../features/auth/authSlice";
import { UserRole } from "../../features/users/usersSlice";
import { CogIcon } from "../common/CogIcon";
import { MainLayout } from "../common/Layouts/Main";
import LoadingOverlay from "../common/LoadingOverlay";
import { CompanyFilter } from "../Filters/Company";
import {
  menuTitles,
  ReportsRoutes,
  ReportTypes,
  sectionTitles,
  sectionTooltips,
} from "./MenuAndRoutes";
import { Prefixes } from "../prefixes";

import styles from "./index.module.scss";
import { getTranslations } from "../../features/translations/translationsUtils";
import { getSelectorsAndSetters } from "./common/interfaces";


export const Reports: FunctionComponent = () => {
   const dispatch = useDispatch();
  // const [filteredInfo, setFilteredInfo] = useState<ReactText[]>([]);
  const [reportType, setReportType] = useState<ReportTypes>();
  const [shouldReset, setShouldReset] = useState(false);
  const cognitoData = useSelector(getCognitoUserData);
  const role = cognitoData ? cognitoData["custom:role"] : undefined;
  const location = useLocation();
  const selectorAndFilter = getSelectorsAndSetters(reportType);
  const filter = useSelector(selectorAndFilter?.selectFilter ?? (() => null));
  const isFetching = useSelector(selectorAndFilter?.selectIsFetching ?? (() => false));

  useEffect(() => {
    setShouldReset(true);
    // setFilteredInfo([]);
    const reportType = Object.keys(sectionTitles()).find((reportType) => {
      return (
        location.pathname.startsWith(`${Prefixes.reports}/${reportType}`)
      );
    });
    if (reportType) {
      setReportType(reportType as ReportTypes);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (shouldReset) {
      setShouldReset(false);
    }
  }, [shouldReset]);

  if (!reportType) {
    return <LoadingOverlay spinning={true} />;
  }

  const setCompanyId = (value: string) => {
    if (selectorAndFilter?.setCompanyId) {
      dispatch(selectorAndFilter.setCompanyId(value));
    }
  }
  const userCompanyId = role !== UserRole.SuperAdmin ? cognitoData?.["custom:company"] : undefined;
  return (
    <MainLayout
      title={sectionTitles()[reportType]}
      rightTopOptions={
        <div className={styles.optionsContainer}>
          <Tooltip
            placement="topLeft"
            title={getTranslations(sectionTooltips[reportType as ReportTypes])}
            className={styles.tooltip}
          >
            <div>
              <CogIcon size="1.4em" color="#81858b" icon={"Attention"} />
            </div>
          </Tooltip>
          {role === UserRole.SuperAdmin &&
            (reportType !== ReportTypes.EducationalContent && reportType !== ReportTypes.Companies) && (
              <CompanyFilter
                onApply={setCompanyId}
                type="report"
                reset={shouldReset}
                value={filter?.companyId}
                disabled={isFetching}
              />
            )}
        </div>
      }
      backgroundColor="#f7f8fa"
      titleContainerClass={styles.report}
      breadcrumbs={[getTranslations('REPORT_BREADCRUMB'), menuTitles()[reportType]]}
    >
      <div className={ctx(styles.container)}>
        <ReportsRoutes companyId={userCompanyId ?? filter?.companyId ?? ""} />
      </div>
    </MainLayout>
  );
};
